import { ChakraV3 } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { useController } from 'react-hook-form';

interface Props extends ChakraV3.NumberInput.RootProps {
  name: string;
}

export const HookedNumberInput = React.forwardRef<HTMLInputElement, Props>(
  (props, forwardedRef) => {
    const { name, defaultValue, ...rest } = props;

    const {
      field: { ref, onChange, ...inputProps },
    } = useController({ name, defaultValue: Number(defaultValue) });

    const mergedRef = ChakraV3.mergeRefs(ref, forwardedRef);

    const handleOnChange = React.useCallback(
      (_valueAsString: string, valueAsNumber: number) => {
        if (P.isStrictNaN(valueAsNumber)) {
          onChange(null);
        } else {
          onChange(valueAsNumber);
        }
      },
      [onChange],
    );

    return (
      <ChakraV3.NumberInput.Root
        colorPalette='brand'
        {...inputProps}
        onValueChange={({ value, valueAsNumber }) => handleOnChange(value, valueAsNumber)}
        value={inputProps.value}
        ref={mergedRef}
        size='sm'
        bg='white'
        w='full'
        allowOverflow={false}
        clampValueOnBlur
        {...rest}
      >
        <ChakraV3.NumberInput.Input rounded='md' />
        <ChakraV3.NumberInput.Control>
          <ChakraV3.NumberInput.IncrementTrigger />
          <ChakraV3.NumberInput.DecrementTrigger />
        </ChakraV3.NumberInput.Control>
      </ChakraV3.NumberInput.Root>
    );
  },
);
